import type { AssetStoryblok } from "@/generated/sb/sb-types";
import { routing } from "@/i18n/routing";
import { getLink } from "@frend-digital/storyblok";

export const getMedia = (blok: AssetStoryblok) => {
	if (!blok || !blok.filename) return null;
	if (blok.filename.endsWith("jpg") || blok.filename.endsWith("png")) {
		const url = blok.filename;
		const pathname = new URL(url).pathname;

		const resolution = pathname.split("/")[3];
		const width = resolution?.split("x")[0];
		const height = resolution?.split("x")[1];

		return {
			url,
			alt: blok.alt,
			width: parseInt(width || "0"),
			height: parseInt(height || "0"),
		};
	}

	if (blok.filename.endsWith("mp4")) {
		return {
			url: blok.filename,
			alt: blok.alt,
			width: 0,
			height: 0,
		};
	}

	return null;
};

export const sbLink = (link: Parameters<typeof getLink>[0] | string) => {
	return getLink(link as Parameters<typeof getLink>[0], routing.removeSegments);
};
